@if (selectedLiveClass) {
  @if (isInstructorView) {
    <div class="pb-2">
      <black-add-recordings
        (addRecording)="addRecordingSession($event)"
        [liveClassId]="selectedLiveClass.id"
      ></black-add-recordings>
    </div>
  }
  @if (!isAuthorized) {
    <div class="daisy-alert daisy-alert-warning shadow-lg">
      <div class="flex items-start gap-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="stroke-current shrink-0 h-6 w-6 mt-0.5"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
        <div class="flex-1">
          <h3 class="font-bold">Subscription Required</h3>
          <p class="text-sm mt-1">
            You need an active subscription to access recordings for this live
            class.
          </p>
        </div>
      </div>
    </div>
  } @else if (recordings.length === 0) {
    <div class="flex flex-col items-center justify-center py-16 px-4">
      <div class="bg-base-200 rounded-full p-6 mb-4">
        <i class="fa-solid fa-video-camera text-4xl text-base-content/40"></i>
      </div>
      <h3 class="text-xl font-semibold text-base-content mb-2">
        No Recordings Available
      </h3>
      <p class="text-base-content/60 text-center max-w-md">
        Recordings will appear here once your sessions are completed and
        processed.
      </p>
    </div>
  } @else {
    @for (item of recordings; track item) {
      <black-recording-card
        (sessionRemoved)="removeRecordingSession($event)"
        [session]="item"
        [showDeleteButton]="isInstructorView"
        (playVideoEvent)="playVideo($event)"
      ></black-recording-card>
    }
  }
} @else {
  <p>Component Failed to load!</p>
}
